










































































































import { CarpsaleManagementCarpsaleService } from "@/common/api";
import QCalendar from "@/common/qCalendar.vue";
import QErrors from "@/common/qErrors.vue";
import qNotify from "@/common/qNotify";
import LiveItemPdfComponent from "@/components/admin/live/common/liveItemPdfComponent.vue";
import QInputMultipleLanguage from "@/components/common/qInputMultipleLanguage.vue";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  name: "ExportItemsComponent",
  components: {
    QCalendar,
    QInputMultipleLanguage,
    LiveItemPdfComponent,
    QErrors,
  },
})
export default class ExportItemsComponent extends Vue {
  public name: "ExportItemsComponent";
  public isShow = false;

  public config = {
    isDisplayCode: true,
    isDisplayPrice: true,
    date: {
      year: String(new Date().getFullYear()),
      month: String(new Date().getMonth() + 1),
      day: String(new Date().getDate()),
    },
    signature: "成田隆輝",
  };

  public errors = {};

  @Prop({
    type: Array,
    default: () => {
      return [];
    },
  })
  public carpsaleItemIds;

  @Watch("isShow")
  public reset() {
    if (this.isShow === false) {
      this.config = {
        isDisplayCode: true,
        isDisplayPrice: true,
        date: {
          year: String(new Date().getFullYear()),
          month: String(new Date().getMonth() + 1),
          day: String(new Date().getDate()),
        },
        signature: "成田隆輝",
      };
    }
  }

  public async clearError(string) {
    console.log(string);
  }
  public async genarete() {
    this.errors = {};
    let result;

    try {
      result = await CarpsaleManagementCarpsaleService.adminCarpsaleGenerateCert(
        {
          ...this.config,
          date: `${this.config.date.year}-${this.config.date.month}-${this.config.date.day}`,
          carpsaleItemIds: this.carpsaleItemIds,
        },
      );

      if (result.status == "success") {
        qNotify.success({
          text: this.$t("common.message.created"),
        });
        this.isShow = false;
      }
    } catch (error) {
      result = error;
      qNotify.error({
        text: result.body.message,
      });

      if (result.status == "400") {
        this.errors = result.body.errors;
      }
    }
  }
}
